import Button from '@mui/material/Button';
import MuiDialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { alpha, styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'Dialog';

const classes = {
  cancel: `${PREFIX}-cancel`,
  delete: `${PREFIX}-delete`,
  paper: `${PREFIX}-paper`,
  text: `${PREFIX}-text`,
  title: `${PREFIX}-title`
};

const StyledMuiDialog = styled(MuiDialog)(({ theme }) => ({
  [`& .${classes.cancel}`]: {
    color: alpha(theme.palette.grey[800], 0.8)
  },

  [`& .${classes.delete}`]: {
    color: theme.palette.error.main
  },

  [`& .${classes.paper}`]: {
    minWidth: theme.breakpoints.values.sm
  },

  [`& .${classes.text}`]: {
    color: alpha(theme.palette.grey[900], 0.62)
  },

  [`& .${classes.title}`]: {
    color: alpha(theme.palette.grey[900], 0.9)
  }
}));

interface DialogProps {
  content: DialogContent;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
interface DialogContent {
  title?: JSX.Element | string;
  text?: JSX.Element | string;
}

const Dialog = ({ content, onClose, onConfirm, isOpen }: DialogProps) => {
  return (
    <StyledMuiDialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ classes: { root: classes.paper } }}
    >
      <DialogTitle data-testid="dialog-title" id="alert-dialog-title">
        {content.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText data-testid="dialog-text" id="alert-dialog-description">
          {content.text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} className={classes.cancel} data-testid="dialog-cancel-button">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          className={classes.delete}
          autoFocus
          data-testid="dialog-delete-button"
        >
          Delete
        </Button>
      </DialogActions>
    </StyledMuiDialog>
  );
};

export default Dialog;
